<div class="loading-animations-outer">
    <img class="bike-icon" src="assets/icons/cycling.svg" />
    <div class="street">
        <div class="str str1"></div>
        <div class="str str2"></div>
        <div class="str str3"></div>
        <div class="str str4"></div>
        <div class="str str5"></div>
        <div class="str str6"></div>
    </div>
</div>